import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sa',
    fullName: 'Sanskrit',
    nativeName: 'संस्कृत भाषा',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "अर्गशून्यम्",
    landing_title: "किञ्चित् आश्चर्यजनकं आगच्छति",
    landing_subtitle: "ArgVoid इति एप् तथा गेम डेवलपमेण्ट् स्टूडियो अस्ति । भवन्तः भवन्तु, नूतनानि वस्तूनि शीघ्रमेव आगच्छन्ति!",
    select_language: "भाषां चिनोतु",
    search_placeholder: "भाषाः अन्वेष्टुम्...",
    terms_title: "सेवानियमाः",
    policy_title: "गोपनीयता नीति",
    cookies_title: "कुकी नीति",
    terms_content: `
        <strong>1. शर्तों की स्वीकृति</strong><br>
        ArgVoid इत्यत्र प्रवेशेन एते सेवानियमाः स्वीक्रियन्ते । यदि एते नियमाः न सम्मताः सन्ति तर्हि सेवायाः उपयोगः न करणीयः।<br><br>

        <strong>2. मञ्चस्य उपयोगः</strong><br>
        ArgVoid तस्य अनुप्रयोगाः च सूचनाप्रदस्य रचनात्मकस्य च प्रयोजनार्थं "यथावत्" प्रदत्ताः सन्ति । सेवायाः उपयोगः केवलं वैधानिकप्रयोजनार्थं अवश्यं करणीयः।<br><br>

        <strong>3. निषिद्ध आचरण</strong><br>
        साइट् दुर्बलतायाः शोषणं, स्पैमिंग्, अथवा आधारभूतसंरचनायाः अनधिकृतप्रवेशस्य प्रयासः सख्यं निषिद्धः अस्ति।<br><br>

        <strong>4. अस्वीकरण</strong><br>
        मञ्चे सेवासु च कदापि सूचनां विना परिवर्तनं कर्तुं शक्यते। सेवायाः अपटाइम् अथवा उपलब्धतायाः विषये कोऽपि वारण्टी न प्रदत्ता।
    `,
    policy_content: `
        <strong>1. सूचना संग्रह</strong><br>
        अस्मिन् समये मञ्चे उपयोक्तृप्रमाणीकरणस्य खातानिर्माणस्य वा आवश्यकता नास्ति । आगन्तुकानां कृते कोऽपि व्यक्तिगतपरिचयसूचना (यथा नाम वा ईमेलपता) सक्रियरूपेण एकत्रिता न भवति।<br><br>

        <strong>2. उपयोग Data</strong><br>
        साइट्-यातायातस्य अवगमनाय, अनुप्रयोगानाम् उन्नयनार्थं च मूलभूतं, अनामिकं विश्लेषणं संग्रहीतुं शक्यते । एषः दत्तांशः व्यक्तिगतप्रयोक्तृपरिचयैः सह न सम्बद्धः अस्ति।<br><br>

        <strong>3. तृतीय-पक्ष सेवा</strong><br>
        तृतीयपक्षप्रदातृणां उपयोगः होस्टिंग्-विश्लेषण-सेवानां कृते भवितुं शक्यते । एतेषां तत्तत्प्रदातृणां गोपनीयताप्रथाः तेषां आधारभूतसंरचनायाः उपरि संसाधितं अनामदत्तांशं नियन्त्रयन्ति।<br><br>

        <strong>4. डेटा सुरक्षा</strong><br>
        मञ्चस्य रक्षणार्थं उचितसुरक्षापरिपाटाः कार्यान्विताः भवन्ति । परन्तु अन्तर्जालमाध्यमेन प्रसारणस्य कोऽपि विधिः पूर्णतया सुरक्षितः नास्ति।<br><br>
    `,
    cookies_content: `
        <strong>1. कुकीजः स्थानीयभण्डारणं च किम्?</strong><br>
        कुकीजः ब्राउजर् स्थानीयभण्डारणं च भ्रमणयोः मध्ये विन्यासप्राथमिकताम् स्मर्तुं उपकरणे संगृहीताः लघुदत्तांशसञ्चिकाः सन्ति।<br><br>

        <strong>2. उपयोग प्रयोजन</strong><br>
        ब्राउजर् LocalStorage इत्यस्य उपयोगः विन्याससेटिंग्स् रक्षितुं सख्तीपूर्वकं भवति, यथा:<br>
        - भाषा प्राथमिकता<br>
        - उपयोक्तृ-अन्तरफलक-विन्यासः (उदा., लेआउट् अथवा विषय-सेटिंग्स्)<br>
        - अस्थायी अनुप्रयोग cache<br><br>

        <strong>3. न Tracking</strong><br>
        कुकीजः स्थानीयभण्डारणं च विज्ञापनार्थं तृतीयपक्षस्य वा अनुसरणं प्रयोजनार्थं न उपयुज्यते । सर्वे संगृहीताः आँकडा: सख्यं मञ्चस्य मूलकार्यक्षमतायाः कृते सन्ति।<br><br>

        <strong>4. नियन्त्रण</strong><br>
        ब्राउजर-दत्तांशं ब्राउजर्-सेटिंग्स्-माध्यमेन कदापि स्वच्छं कर्तुं शक्यते, यत् किमपि स्थानीय-विन्यासं पुनः सेट् करिष्यति ।
    `,
    cookie_consent_text: "वयं वेबसाइट् सम्यक् कार्यं करोति इति सुनिश्चित्य मूलभूतकुकीजस्य उपयोगं कुर्मः, यथा भवतः सत्रं सक्रियं स्थापयितुं, भवतः भाषाप्राथमिकताम् रक्षितुं, अन्ये च कस्टम् विन्यासाः",
    read_policy: "कुकी नीतिं पठन्तु",
    support_title: "समर्थन सह सम्पर्क करें",
    support_subject_label: "विषयः",
    support_message_label: "सन्देशः",
    support_submit_button: "सन्देशं प्रेषयतु",
    support_hint: "नोटः- एतेन सन्देशं प्रेषयितुं भवतः पूर्वनिर्धारितं ईमेल-अनुप्रयोगं उद्घाट्यते ।",
    support_success_msg: "भवतः ईमेल एप् उद्घाटयन्...",
    support_error_msg: "सन्देशं प्रेषयितुं असफलम्। कृपया पश्चात् पुनः प्रयासं कुर्वन्तु।",
    explorer_title: "एक्स्प्लोरर",
    history_title: "इतिहास",
    animation_title: "एनिमेशन",
    config_title: "विन्यासः",
    tool_mouse: "(Ctrl+M) इति चयनं कुर्वन्तु ।",
    tool_brush: "ब्रश (Ctrl+B) ९.",
    tool_brush_mode: "टॉगल मोड (ठोस/स्पष्ट) २.",
    tool_eraser: "इरेजर (Ctrl+E) ९.",
    tool_brush_size: "ब्रश आकार समायोजित करें",
    tool_bucket: "पूरय (Ctrl+F) २.",
    tool_eyedropper: "नेत्रबिन्दुः",
    tool_grid: "जाल (Ctrl+Shift+B) ९.",
    tool_rotate: "घुमाव (Ctrl+Shift+R) २.",
    tool_flip_h: "Flip H (Ctrl+Shift+H) 1 .",
    tool_flip_v: "Flip V (Ctrl+Shift+V) 1।",
    tool_transpose: "ट्रांसपोज (Ctrl+Shift+T) ९.",
    label_width: "विस्तार",
    label_height: "औनत्यम्‌",
    label_frames: "फ्रेम्स की संख्या",
    label_animation: "एनिमेशन शैली",
    label_background_color: "पृष्ठभूमि रंग",
    label_interval: "अन्तराल",
    tool_anim_config: "एनिमेशन विन्यास",
    label_new_width: "नवीन चौड़ाई",
    label_new_height: "नवीन ऊर्ध्वता",
    label_apply: "आचरतु",
    label_colors: "वर्णाः",
    label_size: "आकृति",
    label_tolerance: "सहनशीलता",
    val_horizontal: "क्षैतिज",
    val_vertical: "ऊर्ध्वाधर",
    val_sequence: "श्रेणी",
    val_bounce: "अभि- हन्",
    val_random: "यदृच्छासङ्ख्या",
    val_solid: "ठोस",
    val_clear: "स्पष्टः",
    action_add_sheet: "नवीनं पत्रम्",
    action_import: "आयात",
    action_export: "निर्यात",
    action_sort_projects: "प्रकारं",
    sort_date_old: "प्राचीनतम प्रथम",
    sort_date_new: "नवीनतम प्रथम",
    sort_name_az: "नाम (अ-झ) ९.",
    sort_name_za: "नाम (Z-A) ९.",
    action_new_sprite: "न्यू स्प्राइट",
    action_new_project: "नवीन परियोजना",
    modal_save_all_title: "सर्वाणि परिवर्तनानि रक्षन्तु",
    modal_save_all_desc: "रक्षितुं सम्पत्तिः चिनोतु:",
    modal_save_selected: "चयनितं रक्षतु",
    action_saved: "रक्षितम्",
    modal_create_sprite_title: "New Sprite रचयन्तु",
    modal_create_project_title: "New Project रचयन्तु",
    modal_add_sheet_title: "New Sheet योजयतु",
    modal_rename_sheet_title: "पत्रस्य नाम परिवर्तनं कुर्वन्तु",
    modal_rename_sprite_title: "स्प्राइट् इति नामकरणं कुर्वन्तु",
    modal_delete_sprite_title: "स्प्राइटं विलोपयन्तु",
    modal_delete_project_title: "परियोजनां विलोपयन्तु",
    modal_delete_sheet_title: "पत्रं विलोपयन्तु",
    placeholder_sprite_name: "नामः",
    placeholder_project_name: "नामः",
    placeholder_sheet_name: "नामः",
    placeholder_new_name: "नव नाम",
    action_create: "निर्मियताम्",
    action_add: "संयोजयति",
    action_rename: "पुनर्नाम",
    action_duplicate: "डुप्लिकेट्",
    action_delete: "लुप्",
    action_cancel: "निरसयतु",
    confirm_delete_sprite: "किं भवान् निश्चितः अस्ति यत् भवान् एतत् स्प्राइट् विलोपयितुम् इच्छति?",
    confirm_delete_project: "किं भवान् निश्चितः अस्ति यत् भवान् एतत् परियोजनां विलोपयितुम् इच्छति? सर्वे स्प्राइट्स् निष्कासिताः भविष्यन्ति।",
    confirm_delete_sheet: "किं भवन्तः निश्चयेन एतत् पत्रं विलोपयितुम् इच्छन्ति?",
    err_select_sprite: "कृपया प्रथमं स्प्राइट् चिनोतु ।",
    err_select_project: "कृपया प्रथमं परियोजनां चिनोतु।",
    err_name_empty: "नाम शून्यं न भवितुम् अर्हति।",
    err_sprite_exists: "तत्नाम्ना स्प्राइट् पूर्वमेव विद्यते ।",
    err_project_exists: "तत्नाम्ना परियोजना पूर्वमेव विद्यते ।",
    err_no_content: "रक्षितुं सामग्री नास्ति।",
    err_no_changes: "रक्षितुं परिवर्तनं नास्ति।",
    err_delete_last_sheet: "अन्तिमपत्रं विलोपयितुं न शक्यते ।",
    err_extract_frames: "किमपि फ्रेम्स निष्कासयितुं न शक्तवान्।",
    err_indexeddb: "स्थानीयतया रक्षितुं असफलम्। भवतः ब्राउजर् IndexedDB इत्यस्य समर्थनं न कर्तुं शक्नोति ।",
    msg_upload_success: "अपलोड् सफलम् : {0}",
    msg_upload_failed: "अपलोड् विफलम्: {0}",
    msg_save_success: "सफलं रक्षतु।",
    msg_saving: "बचतम्...",
    msg_multi_save_result: "{0} सम्पत्तिः रक्षिता। {1} विफलता।",
    menu_title: "मेनू",
    menu_save: "रक्ष्",
    menu_save_all: "सर्वं रक्षतु",
    menu_support: "समर्थन सह सम्पर्क करें",
    label_local_storage: "स्थानीय भण्डारण",
    label_sign_in: "साइन इन करें",
    modal_export_title: "निर्यात स्प्राइट",
    label_filename: "सञ्चिकानाम",
    label_format: "प्रारूप",
    action_export_confirm: "निर्यात",
};

export default translations;
